/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

interface IAppContext {
  images: { [key: string]: string };
  svgInline: { [key: string]: React.FC };
  lotties: { [key: string]: string };
  navigation: { [key: string]: { path?: string; translationKey: string; externalPath?: string }[] };
  consts: {
    [key: string]:
      | string
      | number
      | boolean
      | string[]
      | number[]
      | { [key: string]: string | string[] | number[] | React.FC };
  };
  functions: {
    [key: string]: (...args: any) => any;
  };
  post: (data: any) => void;
}

const AppContext = createContext<IAppContext>({
  images: { default: 'abc' },
  svgInline: { default: () => <></> },
  lotties: { default: 'abc' },
  navigation: { default: [{ path: 'abc', translationKey: 'abc' }] },
  consts: { default: 'abc' },
  functions: { default: () => {} },
  post: (data) => {
    console.log(data);
  },
});

export default AppContext;
